export enum PersonTitle {
	Mr = 'Mr',
	Mme = 'Mme',
}

export interface IPerson {
	title?: PersonTitle;
	firstname: string;
	lastname: string;
}
